import { MATERIAL_CATEGORIES } from "@/components/bom/materials";

const fmtNum = (n) =>
  Number.isInteger(n)
    ? n.toLocaleString("en-US")
    : n.toLocaleString("en-US", { maximumFractionDigits: 2 });

const fmtMeters = (mm) =>
  (mm / 1000).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Lengths show both units: "13,000 mm (13.00 m)"; quantities stay "×N". */
const fmtTotal = (material) =>
  material.kind === "length"
    ? `${fmtNum(material.total)} mm (${fmtMeters(material.total)} m)`
    : `×${fmtNum(material.total)}`;

/** Consolidated Total Material List of an order, in the Panel Properties categories. */
export function MaterialList({ orderId, materials }) {
  const nonEmpty = MATERIAL_CATEGORIES.filter(
    ({ key }) => (materials[key] || []).length > 0
  );
  if (nonEmpty.length === 0)
    return (
      <p data-testid={`material-empty-${orderId}`} className="text-[11px] text-slate-400">
        No measurable key/value properties found for these panel types.
      </p>
    );
  return (
    <div
      data-testid={`material-list-${orderId}`}
      className="grid items-start gap-4 md:grid-cols-2 2xl:grid-cols-3"
    >
      {nonEmpty.map(({ key, label }) => (
        <div key={key} data-testid={`material-cat-${key}-${orderId}`}>
          <p className="mono mb-1.5 text-[10px] uppercase tracking-[0.18em] text-slate-500">
            {label} ({materials[key].length})
          </p>
          <div className="space-y-1.5">
            {materials[key].map((material, index) => (
              <div
                key={`${material.kind}:${material.key}`}
                data-testid={`material-row-${orderId}-${key}-${index}`}
                className="flex items-center justify-between gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2"
              >
                <span className="mono truncate text-[11.5px] text-slate-700">{material.key}</span>
                <span className="mono shrink-0 text-[12px] font-semibold text-cyan-700">
                  {fmtTotal(material)}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
